/* ======================================================================== */
/* 29. sliderFullscreen4 */
/* ======================================================================== */
var SliderFullscreen4 = function ($scope) {

	if (!$scope.find('.js-slider-fullscreen4').length) {
		return;
	}

	createSlider();

	function createSlider() {

		var $slider = $('.js-slider-fullscreen4');

		if (!$slider.length) {
			return;
		}

		var
			breakpoints = {},
			lg = elementorFrontend.config.breakpoints.lg - 1 || 1024,
			md = elementorFrontend.config.breakpoints.md - 1 || 767;

		breakpoints[lg] = {
			slidesPerView: $slider.data('slides-per-view-tablet') || 2
		};
		breakpoints[md] = {
			slidesPerView: $slider.data('slides-per-view-mobile') || 1
		};

		var slider = new Swiper($slider[0], {
			slidesPerView: $slider.data('slides-per-view') || 4,
			speed: $slider.data('speed') || 800,
			autoplay: {
				enabled: $slider.data('autoplay-enabled') || false,
				delay: $slider.data('autoplay-delay') || 6000,
			},
			pagination: {
				el: '.js-slider-fullscreen4-progress',
				type: 'progressbar',
				progressbarFillClass: 'slider__progressbar-fill',
				renderProgressbar: function (progressbarFillClass) {
					return '<div class="slider__progressbar"><div class="' + progressbarFillClass + '"></div></div>'
				}
			},
			navigation: {
				prevEl: '.js-slider-fullscreen4-arrow-left',
				nextEl: '.js-slider-fullscreen4-arrow-right',
			},
			mousewheel: {
				eventsTarged: '.section-fullscreen',
				sensitivity: 1
			},
			keyboard: {
				enabled: true
			},
			breakpoints: breakpoints
		});

		renderSliderCounter(
			slider,
			'.js-slider-fullscreen4-counter-current',
			'',
			'.js-slider-fullscreen4-counter-total'
		);

	}

}
